import React from "react";
import { Maintenance } from "../../components/Errors/Maintenance";
import { AppRouter } from "../../router/AppRouter";

export const CustomHome = ({ isMaintenance = false }) => {
	if (isMaintenance) {
		return <Maintenance />;
	} else {
		return <AppRouter />;
	}
};
